import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Refunds() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-white">
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 py-40">
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-12 italic">
          Refund <span className="text-[#DFFF00]">Policy.</span>
        </h1>
        
        <div className="space-y-12 text-slate-400 leading-relaxed text-lg font-medium">
          <section className="border-l-4 border-[#DFFF00] pl-8 py-4 bg-[#DFFF00]/5">
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4 italic">The Core Protocol</h2>
            <p className="text-white font-bold">
              We do NOT offer refunds for any services rendered, except in cases of non-delivery of the agreed-upon assets or infrastructure.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">01. Non-Refundable Items</h2>
            <p>
              Due to the nature of industrial infrastructure setup, including the allocation of dedicated IP blocks, account node creation from zero, and AI compute costs, all setup fees and monthly subscriptions are non-refundable once the deployment process has been initiated.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">02. Exceptions for Delivery</h2>
            <p>
              Refunds will only be considered if:
              <br />A) The specified number of AI video assets was not delivered within the agreed timeframe.
              <br />B) The account nodes were not established or deployed as per the selected tier.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">03. Performance Disclaimer</h2>
            <p>
              Lack of "viral" results, specific view counts, or conversion metrics does not constitute non-delivery. Our service is infrastructure-based; we guarantee the pipes and the fuel (AI assets), not the platform's algorithmic reaction.
            </p>
          </section>

          <p className="pt-12 border-t border-white/10 text-xs text-slate-600 font-black uppercase tracking-[0.4em]">
            REFUND_STATUS: <span className="text-red-500">STRICT_ENFORCEMENT</span> // LAST_MODIFIED: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}